import { AuthProvider } from '@/lib/auth';
import { SyncProvider } from '@/lib/sync';
import { AppRoutes } from '@/routes';
import { Toaster } from './components/ui/Toaster';

function App() {
  return (
    <AuthProvider>
      <SyncProvider>
        <div className="min-h-screen">
          <AppRoutes />
        </div>
        <Toaster />
      </SyncProvider>
    </AuthProvider>
  );
}

export default App;
